import { render, staticRenderFns } from "./PageModal.vue?vue&type=template&id=69ffe7a7&scoped=true&"
import script from "./PageModal.vue?vue&type=script&lang=ts&"
export * from "./PageModal.vue?vue&type=script&lang=ts&"
import style0 from "./PageModal.vue?vue&type=style&index=0&id=69ffe7a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ffe7a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69ffe7a7')) {
      api.createRecord('69ffe7a7', component.options)
    } else {
      api.reload('69ffe7a7', component.options)
    }
    module.hot.accept("./PageModal.vue?vue&type=template&id=69ffe7a7&scoped=true&", function () {
      api.rerender('69ffe7a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/modal/PageModal.vue"
export default component.exports